// Package Imports
import RouteError from '@/core/components/route-error'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

// External Module Imports
import { dashboardRoute } from '@/modules/dashboard/dashboard.routes'

export const profileRoute = createRoute({
  getParentRoute: () => dashboardRoute,
  errorComponent: ({ error, reset }) => (
    <RouteError error={error} reset={reset} />
  ),
  path: '/profile',
  component: lazyRouteComponent(
    () => import('@/modules/profile/pages/profile.page')
  ),
})
